<template>
  <div class="pc-anylise inner-box">
    <Bread backTitle="解析数据"></Bread>
    <h1 class="title">解析数据</h1>
    <p class="infos">您可以在此页面输入未签名的源数据，十六进制格式文本，将会解析成可读的格式。</p>
    <textarea name class="textvalue" v-model="param"></textarea>
    <div class="sub-btn flex-center" @click="submit(param)" :class="{ disabled: isDisabled }">解析数据</div>

    <pre class="inputTxt" contenteditable="true" v-if="result"><code>{{ result }}</code></pre>
  </div>
</template>

<script setup>
import Bread from "@/components/computer/Breadcrumb.vue";
import ToolMixins from "@/mixins/tool";
import { ref } from "vue";

const param = ref();
const { result, isDisabled, submit } = ToolMixins();
</script>

<style lang="scss" scoped>
.pc-anylise {
  .title {
    margin-top: 30px;
    font-size: 16px;
    font-family: PingFangSC-Semibold;
    font-weight: 500;
    color: $black_title;
  }
  .infos {
    margin: 10px 0 30px;
    font-size: 14px;
    font-weight: 400;
    color: $font_grey;
  }
  .sub-btn {
    width: 180px;
    height: 45px;
    margin: 20px auto;
    background: $blue;
    border-radius: 25px;
    color: $white;
    font-size: 14px;
    cursor: pointer;
    transition: 0.3s;
  }
  .sub-btn:hover {
    opacity: 0.8;
  }
  .sub-btn:active {
    opacity: 1;
  }
  .disabled {
    background: $grey_deep;
    cursor: not-allowed;
  }
  .textvalue {
    width: 100%;
    height: 200px;
    padding: 20px;
    background: rgba(255, 255, 255, 1);
    border-radius: 2px;
    border: 2px solid rgba(235, 239, 241, 1);
    resize: none;
    font-size: 14px;
  }
  .inputTxt {
    height: 250px;
    vertical-align: middle;
    overflow-y: auto;
    width: 100%;
    line-height: 14px;
    word-break: break-all;
    padding: 11px;
    background: $white;
    border-radius: 2px;
    border: 2px solid rgba(235, 239, 241, 1);
    font-size: 14px;
  }
  .inputTxt::-webkit-scrollbar,
  .textvalue::-webkit-scrollbar {
    width: 1px;
    height: 1px;
    cursor: pointer;
  }
}
</style>
